import "./FormSection.css";

export default function FormSection({ title, children }) {
    return (
        <section className="form-section fade-in">
            <p className="section-title">{title}</p>
            {children}
        </section>
    )
}